/*
 * @Descripttion: 通用后缀固定字段规则的方法
 * @Author: shenah
 * @Date: 2023-04-25 17:31:04
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:33:15
 */
import {
  extendDefaultAttr,
  createOneRule,
} from "_dataview/output/config/prefixSuffixRuleConfig";
export default {
  methods: {
    handlePrefixSuffixStyle(config, row, defaultObj = {}) {
      let style = this.handlePrefixSuffixRule(config, row, defaultObj) || {};
      return {
        position: "relative",
        "font-size": this.transPX(style.fontSize),
        top: this.transPX(style.relative?.top),
        bottom: this.transPX(style.relative?.bottom),
        left: this.transPX(style.relative?.left),
        right: this.transPX(style.relative?.right),
        color: style.color,
        fontWeight: style.fontWeight,
        other: style,
      };
    },
    handlePrefixSuffixRule(obj, nowData, defaultObj) {
      if (!obj || !nowData) return;
      let { defaultForm = {}, ruleList = [] } = obj;
      let value = {
        ...createOneRule(),
        ...defaultForm,
        showType: defaultObj.defaultRuleShowType,
        icon: defaultObj.defaultRuleIcon,
        content: defaultObj.defaultRuleContent,
        imgObj: defaultObj.defaultRuleImg,
      };
      for (let i = 0; i < ruleList.length; i++) {
        let ruleObj = ruleList[i];
        try {
          let flag = this.$eval(ruleObj.rule, nowData);
          if (flag) {
            value = this.handleExtendDefaultAttr(value, ruleObj);
            break;
          }
        } catch (error) {
          console.log("handlePrefixSuffixRule", error);
        }
      }
      return value;
    },
    // 如果为空或者为null 则继承默认配置
    handleExtendDefaultAttr(defaultForm, nowForm) {
      let newDefaultForm = _.cloneDeep(defaultForm);
      let newNowForm = _.cloneDeep(nowForm);
      let form = newNowForm;
      extendDefaultAttr.forEach((key) => {
        if (!form[key]) {
          form[key] = newDefaultForm[key];
        } else if (typeof form[key] === "object") {
          form[key] = newDefaultForm[key];
        }
      });
      // 展示内容与展示方式需要特殊处理
      if (
        (newNowForm.showType === "icon" && !newNowForm.icon) ||
        (newNowForm.showType === "content" && !newNowForm.content) ||
        (newNowForm.showType === "img" && !newNowForm.imgObj.src)
      ) {
        form.showType = newDefaultForm.showType;
        form.content = newDefaultForm.content;
        form.icon = newDefaultForm.icon;
        form.imgObj = newDefaultForm.imgObj;
      }
      return form;
    },
    handleExpressionContent(str, nowData) {
      try {
        return this.$eval(str, nowData);
      } catch (error) {
        return str;
      }
    },
  },
};
